import { Color3, Scene } from '@babylonjs/core';

export class FogConfig {
  constructor(
    public mode = Scene.FOGMODE_LINEAR,
    public density: number = 0.1,
    public color = new Color3(0.8, 0.8, 0.8),
    public fogStart: number = 50.0,
    public fogEnd: number = 500.0
  ) {}
}
